import { translateFn } from '../../../utils/translator.helper';
import { API_TYPE_INTEGRATIONS_MARKETPLACE } from '../../../webcomponents.constants';
import { ColumnType } from '../../../grid/types/common';

const ALL = 'all';

export enum ColumnKeys {
  COMPANY = 'company',
  STATUS = 'status',
  CATEGORY = 'category',
}

export enum Column {
  COMPANY = 0,
  STATUS = 1,
  CATEGORY = 2,
}

export enum COLUMNS_FILTERS {
  COMPANY = 'Company',
  STATUS = 'Status',
  CATEGORY = 'Type',
}

export enum STATUS_FILTER {
  NOT_LICENSED = 0,
  AVAILABLE = 1,
  STOPPED = 2,
  ACTION_REQUIRED = 3,
  PENDING = 4,
  ACTIVE = 5,
  ERROR = 6,
  USAGE_LIMIT_REACHED = 7,
}

export enum CATEGORY_FILTER {
  DIRECTORY_SERVICES = 'directoryServices',
  VIRTUALIZATION = 'virtualization',
  EMAIL_SECURITY = 'emailSecurity',
  IDENTITY_PROVIDERS = 'identityProviders',
  MOBILE_SECURITY = 'mobileSecurity',
  CLOUD_SECURITY = 'cloudSecurity',
  SIEM = 'siem',
  BACKUP = 'backup',
  XDR = 'xdr',
  RMM = 'rmm',
  INVENTORY_MANAGEMENT = 'inventoryManagement',
  SECURITY_TRAINING = 'securityTraining',
}

export const PREDEFINED_FILTERS_KEYS = [ColumnKeys.COMPANY, ColumnKeys.STATUS, ColumnKeys.CATEGORY];

function getBaseColumnDetails() {
  return [
    {
      column: Column.STATUS,
      key: ColumnKeys.STATUS,
      columnName: translateFn(COLUMNS_FILTERS.STATUS),
      type: 1,
      values: [
        { label: translateFn('Available'), value: STATUS_FILTER.AVAILABLE },
        { label: translateFn('License required'), value: STATUS_FILTER.NOT_LICENSED },
        { label: translateFn('Stopped'), value: STATUS_FILTER.STOPPED },
        { label: translateFn('Action required'), value: STATUS_FILTER.ACTION_REQUIRED },
        { label: translateFn('Pending'), value: STATUS_FILTER.PENDING },
        { label: translateFn('Active'), value: STATUS_FILTER.ACTIVE },
        { label: translateFn('Error'), value: STATUS_FILTER.ERROR },
        { label: translateFn('Usage limit reached'), value: STATUS_FILTER.USAGE_LIMIT_REACHED },
      ],
      removable: false,
      filterResetValue: {
        in: [
          STATUS_FILTER.AVAILABLE,
          STATUS_FILTER.NOT_LICENSED,
          STATUS_FILTER.STOPPED,
          STATUS_FILTER.ACTION_REQUIRED,
          STATUS_FILTER.PENDING,
          STATUS_FILTER.ACTIVE,
          STATUS_FILTER.ERROR,
          STATUS_FILTER.USAGE_LIMIT_REACHED,
        ],
      },
    },
    {
      column: Column.CATEGORY,
      key: ColumnKeys.CATEGORY,
      columnName: translateFn(COLUMNS_FILTERS.CATEGORY),
      type: 1,
      values: [
        { label: translateFn('Backup'), value: CATEGORY_FILTER.BACKUP },
        { label: translateFn('Directory Services'), value: CATEGORY_FILTER.DIRECTORY_SERVICES },
        { label: translateFn('Inventory Management'), value: CATEGORY_FILTER.INVENTORY_MANAGEMENT },
        { label: translateFn('Virtualization'), value: CATEGORY_FILTER.VIRTUALIZATION },
        { label: translateFn('Email Protection'), value: CATEGORY_FILTER.EMAIL_SECURITY },
        { label: translateFn('Security Training'), value: CATEGORY_FILTER.SECURITY_TRAINING },
        { label: translateFn('Cloud Security'), value: CATEGORY_FILTER.CLOUD_SECURITY },
      ],
      removable: false,
      filterResetValue: {
        in: [
          CATEGORY_FILTER.BACKUP,
          CATEGORY_FILTER.DIRECTORY_SERVICES,
          CATEGORY_FILTER.INVENTORY_MANAGEMENT,
          CATEGORY_FILTER.VIRTUALIZATION,
          CATEGORY_FILTER.EMAIL_SECURITY,
          CATEGORY_FILTER.SECURITY_TRAINING,
          CATEGORY_FILTER.CLOUD_SECURITY,
        ],
      },
    },
  ];
}

function addCompanyColumn(columns: any[]) {
  columns.unshift({
    column: Column.COMPANY,
    key: ColumnKeys.COMPANY,
    columnName: translateFn(COLUMNS_FILTERS.COMPANY),
    type: ColumnType.COMPANY,
    removable: false,
    filterResetValue: [Application.Main.user.company.id],
    showOnlySelectAll: true,
    remoteDetails: {
      type: API_TYPE_INTEGRATIONS_MARKETPLACE,
    },
  });
}

export function getColumnDetails(isPartner: boolean) {
  const columns = getBaseColumnDetails();
  if (isPartner) {
    addCompanyColumn(columns);
  }
  return columns;
}

function getBaseFiltersGrids() {
  return [
    {
      status: {
        in: [
          STATUS_FILTER.AVAILABLE,
          STATUS_FILTER.NOT_LICENSED,
          STATUS_FILTER.STOPPED,
          STATUS_FILTER.ACTION_REQUIRED,
          STATUS_FILTER.PENDING,
          STATUS_FILTER.ACTIVE,
          STATUS_FILTER.ERROR,
          STATUS_FILTER.USAGE_LIMIT_REACHED,
        ] as STATUS_FILTER[],
      },
    },
    {
      category: {
        in: [
          CATEGORY_FILTER.BACKUP,
          CATEGORY_FILTER.DIRECTORY_SERVICES,
          CATEGORY_FILTER.INVENTORY_MANAGEMENT,
          CATEGORY_FILTER.VIRTUALIZATION,
          CATEGORY_FILTER.EMAIL_SECURITY,
          CATEGORY_FILTER.SECURITY_TRAINING,
          CATEGORY_FILTER.CLOUD_SECURITY,
        ] as CATEGORY_FILTER[],
      },
    },
  ];
}

export function getCompanyFilter() {
  return {
    company: { in: [Application.Main.user.company.id] },
  };
}

export function addCompanyFilter(filters: any[]) {
  filters.unshift(getCompanyFilter());
}

export function getDefaultFiltersGrids(isPartner: boolean) {
  const filters = getBaseFiltersGrids();
  if (isPartner) {
    addCompanyFilter(filters);
  }
  return filters;
}

export function getAllGridFilters() {
  const filters = getBaseFiltersGrids();
  addCompanyFilter(filters);
  return filters;
}
